import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Input, message, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Scroll from 'react-scroll';
import { CognitoUserPool, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { POOL_DATA, USERNAME_URL } from "../../../utils/config";

import GetStarted from '../GetStarted';
import Sign from '../Sign';
import Confirm from './Confirm';

import './Register.css';

class Register extends Component {

  state = {
    confirmDirty: false,
    userName: '',
    visible: false,
    email: '',
    loading: false,
    inviteCode: ''
  };


  componentWillMount() {
    const userPool = new CognitoUserPool(POOL_DATA);

    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return;
        }
        if (session.isValid() === true) {
          this.props.history.push('/profile');
        }
      });
    }
  }

  static getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
      const pair = vars[i].split("=");
      if (pair[0] === variable){ return pair[1] }
    }
    return('');
  }

  componentDidMount() {
    const inviteCode = this.constructor.getQueryVariable('invite');
    this.setState({
      inviteCode,
    })
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Password is not match.');
    } else {
      callback();
    }
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {

      if (!err) {
        this.setState({
          loading: true,
        });

        const userPool = new CognitoUserPool(POOL_DATA);
        const attributeList = [];
        const dataEmail = {
          Name : 'email',
          Value : values.email
        };
        const dataInvitationCode = {
          Name : 'custom:invitationCode',
          Value : values.invite === undefined ? '' : values.invite,
        };

        const attributeEmail = new CognitoUserAttribute(dataEmail);
        const attributeInvitationCode = new CognitoUserAttribute(dataInvitationCode);

        attributeList.push(attributeEmail);
        attributeList.push(attributeInvitationCode);

        const userNameUrl = `${USERNAME_URL}?email=${values.email}`;
        fetch(userNameUrl, {
          method: 'GET'
        })
          .then(res => res.json())
          .then((data) => {
            const dataInvitationToken = {
              Name: 'custom:invitationToken',
              Value: data.generatedInvitateCode,
            };
            const attributeInvitationToken = new CognitoUserAttribute(dataInvitationToken);
            attributeList.push(attributeInvitationToken);


            userPool.signUp(data.generatedUserName, values.password, attributeList, null, (err, result) => {
              if (err) {

                if (String(err).indexOf('User already exists') !== -1) {
                  message.error('This email has been registered, please sign in');
                } else {
                  message.error(String(err).split(': ')[1]);
                }
                this.setState({
                  loading: false,
                });
                return;
              }
              if (!err) {
                this.setState({
                  visible: true,
                  userName: result.user.getUsername(),
                  email: values.email,
                });
                this.setState({
                  loading: false,
                })
              }
              this.setState({
                loading: false,
              })
            });
          })
      }
    });
  };

  checkEmail = (rule, value, callback) => {
    const form = this.props.form;
    if (/[A-Z]/.test(form.getFieldValue('email'))) {
      callback('Email must be lowercase');
    } else {
      callback();
    }
  };

  handleScroll = () => {
    Scroll.animateScroll.scrollTo(211, {
      duration: 800,
      smooth: 'easeOutQuad'
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="Register">
        <Helmet>
          <title>Sign up - Qbates</title>
          <meta name="description" content="Get started and Join us" />
        </Helmet>
        <GetStarted/>
        <Sign/>
        <Confirm visible={this.state.visible} userName={this.state.userName} email={this.state.email}/>
        <Spin spinning={this.state.loading}>
        <Form onSubmit={this.handleSubmit} className="register-form">
          <Form.Item hasFeedback>
            <span>Email</span>
            {getFieldDecorator('email', {
              rules: [
                { type: 'email', message: 'The input is not valid E-mail' },
                { required: true, message: 'Please input your Email' },
                { validator: this.checkEmail }
              ],
            })(
              <Input type="email" placeholder="Email" onFocus={this.handleScroll.bind(this)}/>
            )}
          </Form.Item>
          <Form.Item hasFeedback>
            <span>Password</span>
            {getFieldDecorator('password', {
              rules: [
                { required: true, message: 'Please input your Password '},
                { min: 8, message: 'Password is too short ( need more than 8 characters ).' },
                { validator: this.checkConfirm }
              ],
            })(
              <Input type="password" placeholder="Password" onFocus={this.handleScroll.bind(this)}/>
            )}
          </Form.Item>
          <Form.Item hasFeedback>
            <span>Confirm password</span>
            {getFieldDecorator('confirm', {
              rules: [
                { required: true, message: 'Please repeat your Password' },
                { validator: this.checkPassword }],
            })(
              <Input type="password" placeholder="Enter again" onBlur={this.handleConfirmBlur} onFocus={this.handleScroll.bind(this)}/>
            )}
          </Form.Item>
          <Form.Item hasFeedback>
            <span>Invitation code ( Optional )</span>
            {getFieldDecorator('invite', {
              initialValue: this.state.inviteCode
            })(
              <Input type="text" placeholder="Invitation code" onFocus={this.handleScroll.bind(this)}/>
            )}
          </Form.Item>
          <Form.Item>
            <p>By sign up a new account, means you agree with our <Link to="/policy-agreement">Privacy Policy</Link>.</p>
          </Form.Item>
          <Form.Item className="register-button">
            <button>SIGN UP</button>
          </Form.Item>
        </Form>
        </Spin>
      </div>
    );
  }
}

const WrappedRegister = Form.create()(Register);
export default withRouter(WrappedRegister);


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Register.js